import React from 'react'
import { useTranslation } from 'react-i18next';

import ReceiptClockIcon from 'pages/assets/icons/ReceiptClockIcon'

function PendingPayment ({ order }) {

  const { t } = useTranslation()

  return (
    <section className='mt-20 mb-24'>
      <div className='space-y-8 app-main-container'>
        <div className='flex flex-col items-center pt-20 space-y-4'>
          <ReceiptClockIcon />
          <p className='text-xl font-bold text-center sm:text-2xl text-app-blue-2'>{t('successRegistrationHeading')}</p>
        </div>
        <p className='text-xs text-center sm:text-sm sm:mx-16'>
          {t('successRegistrationDisclaimer')}
        </p>
      </div>
    </section>
  )

}

export default PendingPayment